"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const Card_1 = __importDefault(require("@mui/material/Card"));
const styles_1 = require("@mui/material/styles");
const CardContent_1 = __importDefault(require("@mui/material/CardContent"));
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const AppBar_1 = __importDefault(require("@mui/material/AppBar"));
const Toolbar_1 = __importDefault(require("@mui/material/Toolbar"));
const CssBaseline_1 = __importDefault(require("@mui/material/CssBaseline"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const Stack_1 = __importDefault(require("@mui/material/Stack"));
const services_1 = require("../services");
const react_router_dom_1 = require("react-router-dom");
const react_1 = require("react");
const shared_1 = require("../shared");
const material_react_table_1 = require("material-react-table");
const material_1 = require("@mui/material");
const InputLabel_1 = __importDefault(require("@mui/material/InputLabel"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const FormControl_1 = __importDefault(require("@mui/material/FormControl"));
const Select_1 = __importDefault(require("@mui/material/Select"));
const Processing_1 = __importDefault(require("../components/Processing"));
const Item = (0, styles_1.experimentalStyled)(Paper_1.default)(({ theme }) => (Object.assign(Object.assign({ backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff' }, theme.typography.body2), { padding: theme.spacing(2), textAlign: 'center', 
    // '&:hover': {
    //     backgroundColor: 'primary.main',
    //     opacity: [0.9, 0.8, 0.7],
    // },
    color: theme.palette.text.secondary })));
function DiagMod({ id, name, updateSelection }) {
    const [checked, setChecked] = React.useState(false);
    const handleChange = (event) => {
        setChecked(event.target.checked);
        if (updateSelection) {
            updateSelection(id, event.target.checked);
        }
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(Item, { children: [(0, jsx_runtime_1.jsx)(Checkbox_1.default, { checked: checked, onChange: handleChange, inputProps: { 'aria-label': 'controlled' } }), name] }) }));
}
function Home({ fulllength }) {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [quizId, setQuizId] = (0, react_1.useState)(null);
    const [selectedDiag, setSelectedDiag] = (0, react_1.useState)([]);
    const [diagnosticList, setDiagnosticList] = (0, react_1.useState)([]);
    const [userData, setUserData] = (0, react_1.useState)(null);
    const [registrationDetails, setRegistrationDetails] = (0, react_1.useState)({});
    const { testTypeID } = (0, react_router_dom_1.useParams)();
    const [testType, setTestType] = React.useState(testTypeID);
    const { data: diagnostics, isLoading, refetch } = (0, services_1.useDiagnosticsQuery)(parseInt(testType));
    const [addDiagnostic, { isLoading: isCreating }] = (0, services_1.useCreateDiagnosticMutation)();
    const [diagnosticData, setDiagnosticData] = (0, react_1.useState)([]);
    const [testTypeList, setTestTypeList] = React.useState([]);
    (0, react_1.useEffect)(() => {
        initGet();
    }, []);
    const initGet = async () => {
        const user = await (0, shared_1.getCurrentUser)();
        setUserData(user || null);
        setRegistrationDetails(await (0, shared_1.getUserDataById)(user === null || user === void 0 ? void 0 : user.id));
        setTestTypeList(await (0, shared_1.getStrapiData)(`test-types?&sort=displayOrder:asc`));
    };
    const handleUpdateSelection = (id, checked) => {
        if (checked) {
            const index = selectedDiag.indexOf(id);
            if (index === -1) {
                setSelectedDiag([...selectedDiag, id]);
            }
        }
        else {
            const index = selectedDiag.indexOf(id);
            if (index !== -1) {
                selectedDiag.splice(index, 1);
                setSelectedDiag([...selectedDiag]);
            }
        }
    };
    const handleStartQuiz = async () => {
        var _a;
        let userId = userData === null || userData === void 0 ? void 0 : userData.id;
        if (!userId) {
            const user = await (0, shared_1.getCurrentUser)();
            userId = (user === null || user === void 0 ? void 0 : user.id) || '123';
        }
        if (!quizId && userId) {
            let selectedDiagnostics = selectedDiag;
            if (fulllength) {
                selectedDiagnostics = [];
                (((_a = diagnostics === null || diagnostics === void 0 ? void 0 : diagnostics.diagnostics) === null || _a === void 0 ? void 0 : _a.data) || []).forEach((i) => {
                    var _a;
                    if ((_a = i === null || i === void 0 ? void 0 : i.attributes) === null || _a === void 0 ? void 0 : _a.IsFullLength)
                        selectedDiagnostics.push(i.id);
                });
                setSelectedDiag(selectedDiagnostics);
            }
            const diag = await addDiagnostic({ userId: userId, diagnostics: selectedDiagnostics, type: fulllength ? 1 : 0, testtype: parseInt(testTypeID) }).unwrap();
            setQuizId(diag.quizId);
        }
        else {
            navigate(`/diagnostics/quiz/${quizId}`);
        }
    };
    const handleSelection = async (cell, fullLength) => {
        var _a, _b, _c;
        let userId = userData === null || userData === void 0 ? void 0 : userData.id;
        if (!userId) {
            const user = await (0, shared_1.getCurrentUser)();
            userId = (user === null || user === void 0 ? void 0 : user.id) || '123';
        }
        if (!quizId && userId) {
            let selectedDiagnostics = [(_b = (_a = cell === null || cell === void 0 ? void 0 : cell.row) === null || _a === void 0 ? void 0 : _a.original) === null || _b === void 0 ? void 0 : _b.id];
            let selectedMod = [];
            if (fullLength) {
                selectedDiagnostics = [];
                (((_c = cell === null || cell === void 0 ? void 0 : cell.row) === null || _c === void 0 ? void 0 : _c.leafRows) || []).forEach((i) => {
                    var _a, _b;
                    if ((_a = i === null || i === void 0 ? void 0 : i.original) === null || _a === void 0 ? void 0 : _a.id)
                        selectedDiagnostics.push((_b = i === null || i === void 0 ? void 0 : i.original) === null || _b === void 0 ? void 0 : _b.id);
                });
                selectedMod.push(selectedDiagnostics[0]);
                setSelectedDiag(selectedMod);
            }
            else {
                selectedMod.push(selectedDiagnostics[0]);
            }
            const diag = await addDiagnostic({ userId: userId, diagnostics: selectedMod, type: fullLength ? 1 : 0, testtype: parseInt(testType) }).unwrap();
            setQuizId(diag.quizId);
        }
    };
    const handleStartQuizNew = async () => {
        navigate(`/diagnostics/quiz/${quizId}`);
    };
    const handleChange = (event) => {
        setTestType(event.target.value);
    };
    (0, react_1.useEffect)(() => {
        refetch();
    }, [testType]);
    // React.useEffect(() => {
    // 	if (fulllength) {
    // 		handleStartQuiz();
    // 	}
    // }, [fulllength]);
    React.useEffect(() => {
        var _a, _b;
        if (diagnostics) {
            let tempDiagList = [];
            (_b = (_a = diagnostics === null || diagnostics === void 0 ? void 0 : diagnostics.diagnostics) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.map((diag) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
                let qCount = 0;
                (_b = (_a = diag === null || diag === void 0 ? void 0 : diag.attributes) === null || _a === void 0 ? void 0 : _a.QuestionCount) === null || _b === void 0 ? void 0 : _b.forEach((set) => {
                    qCount += (set === null || set === void 0 ? void 0 : set.Count) || 0;
                });
                const newData = {
                    id: parseInt((diag === null || diag === void 0 ? void 0 : diag.id) || 0),
                    category: ((_c = diag === null || diag === void 0 ? void 0 : diag.attributes) === null || _c === void 0 ? void 0 : _c.Category) || '',
                    name: ((_d = diag === null || diag === void 0 ? void 0 : diag.attributes) === null || _d === void 0 ? void 0 : _d.Name) || '',
                    area: ((_e = diag === null || diag === void 0 ? void 0 : diag.attributes) === null || _e === void 0 ? void 0 : _e.Area) || '',
                    testTypeID: parseInt(((_h = (_g = (_f = diag === null || diag === void 0 ? void 0 : diag.attributes) === null || _f === void 0 ? void 0 : _f.TestType) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.id) || 0),
                    testType: ((_m = (_l = (_k = (_j = diag === null || diag === void 0 ? void 0 : diag.attributes) === null || _j === void 0 ? void 0 : _j.TestType) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.attributes) === null || _m === void 0 ? void 0 : _m.Name) || '',
                    firstGroup: ((_o = diag === null || diag === void 0 ? void 0 : diag.attributes) === null || _o === void 0 ? void 0 : _o.IsFullLength) ? 'Adaptive Full Length Tests' : 'Diagnostic Tests',
                    isFullLength: ((_p = diag === null || diag === void 0 ? void 0 : diag.attributes) === null || _p === void 0 ? void 0 : _p.IsFullLength) || false,
                    description: ((_q = diag === null || diag === void 0 ? void 0 : diag.attributes) === null || _q === void 0 ? void 0 : _q.Description) || '',
                    questionCount: qCount || 0,
                    timeAlloted: Math.round(((_r = diag === null || diag === void 0 ? void 0 : diag.attributes) === null || _r === void 0 ? void 0 : _r.Duration) / 60 || 0),
                };
                if ((_s = diag === null || diag === void 0 ? void 0 : diag.attributes) === null || _s === void 0 ? void 0 : _s.IsSchoolPresent) {
                    let diagSchool = (_t = diag === null || diag === void 0 ? void 0 : diag.attributes) === null || _t === void 0 ? void 0 : _t.School;
                    if (diagSchool && ((_v = (_u = diagSchool === null || diagSchool === void 0 ? void 0 : diagSchool.data) === null || _u === void 0 ? void 0 : _u.id) === null || _v === void 0 ? void 0 : _v.toString()) === ((_w = registrationDetails === null || registrationDetails === void 0 ? void 0 : registrationDetails.studentSchool) === null || _w === void 0 ? void 0 : _w.toString())) {
                        tempDiagList.push(newData);
                    }
                }
                else {
                    tempDiagList.push(newData);
                }
            });
            const sortedArray = tempDiagList.sort((a, b) => {
                if (a.firstGroup < b.firstGroup)
                    return -1;
                if (a.firstGroup > b.firstGroup)
                    return 1;
                if (a.category < b.category)
                    return -1;
                if (a.category > b.category)
                    return 1;
                return 0;
            });
            setDiagnosticData(sortedArray);
        }
    }, [diagnostics]);
    if (isLoading || isCreating)
        return (0, jsx_runtime_1.jsx)(Processing_1.default, { isProceesing: true });
    const columns = [
        {
            header: '',
            accessorKey: 'firstGroup',
        },
        {
            header: 'Category',
            accessorKey: 'category',
        },
        {
            header: 'Diagnostic Name / Mastery Type',
            accessorKey: 'name',
            enableGrouping: false,
        },
        {
            header: 'Test Type',
            accessorKey: 'testType',
            enableGrouping: false,
        },
        {
            header: 'Area',
            accessorKey: 'area',
            enableGrouping: false,
        },
        {
            header: 'Description',
            accessorKey: 'description',
            enableGrouping: false,
            Cell: ({ cell }) => { var _a, _b; return (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ sx: { whiteSpace: 'normal', wordWrap: 'break-word' } }, { children: (_b = (_a = cell === null || cell === void 0 ? void 0 : cell.row) === null || _a === void 0 ? void 0 : _a.original) === null || _b === void 0 ? void 0 : _b.description })); },
        },
        {
            header: 'Number of Questions',
            accessorKey: 'questionCount',
            enableGrouping: false,
            size: 50,
        },
        {
            header: 'Time (Min.)',
            accessorKey: 'timeAlloted',
            enableGrouping: false,
            size: 50,
        },
        {
            header: 'Select To Take The Test',
            accessorKey: 'id',
            size: 120,
            AggregatedCell: ({ cell }) => {
                var _a, _b, _c, _d;
                if (((_a = cell === null || cell === void 0 ? void 0 : cell.row) === null || _a === void 0 ? void 0 : _a.groupingColumnId) === 'firstGroup' || (((_b = cell === null || cell === void 0 ? void 0 : cell.row) === null || _b === void 0 ? void 0 : _b.groupingColumnId) === 'category' && !((_d = (_c = cell === null || cell === void 0 ? void 0 : cell.row) === null || _c === void 0 ? void 0 : _c.original) === null || _d === void 0 ? void 0 : _d.isFullLength)))
                    (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
                else
                    return ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: 'contained', sx: { borderRadius: 20, backgroundColor: '#70ad47' }, onClick: () => handleSelection(cell, true) }, { children: "Select" })));
            },
            Cell: ({ cell, table }) => {
                var _a, _b, _c, _d, _e, _f;
                if (((_b = (_a = cell === null || cell === void 0 ? void 0 : cell.row) === null || _a === void 0 ? void 0 : _a.original) === null || _b === void 0 ? void 0 : _b.isFullLength) || ((((_c = cell === null || cell === void 0 ? void 0 : cell.row) === null || _c === void 0 ? void 0 : _c.groupingColumnId) === 'firstGroup' || ((_d = cell === null || cell === void 0 ? void 0 : cell.row) === null || _d === void 0 ? void 0 : _d.groupingColumnId) === 'category') && !((_f = (_e = cell === null || cell === void 0 ? void 0 : cell.row) === null || _e === void 0 ? void 0 : _e.original) === null || _f === void 0 ? void 0 : _f.isFullLength)))
                    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
                else
                    return ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ variant: 'contained', sx: { borderRadius: 20, backgroundColor: '#70ad47' }, onClick: () => handleSelection(cell, false) }, { children: "Select" })));
            },
        },
    ];
    const width = !quizId ? 500 : 345;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(CssBaseline_1.default, {}), (0, jsx_runtime_1.jsxs)(Paper_1.default, Object.assign({ sx: { height: '100%', paddingTop: 2 } }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'h5', sx: {
                            textAlign: 'center',
                            margin: '10px auto',
                            fontSize: '2rem',
                        } }, { children: quizId ? 'Instructions' : 'Study Center / Diagnostic Selection​' })), !quizId && ((0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, sx: { padding: 1 }, spacing: 1, direction: 'column' }, { children: [(0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: true }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ sx: { textAlign: 'center', margin: '0 9%', color: '#4472c4', fontSize: '1.25rem' } }, { children: "Below is a list of available diagnostics that you may choose to take. The diagnostics range from complete full length tests to skills building to meet your specific study plan. Only have 5 minutes? No Problem!" })) })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: true }, { children: (0, jsx_runtime_1.jsxs)(FormControl_1.default, Object.assign({ sx: { m: 1, minWidth: '25vw' } }, { children: [(0, jsx_runtime_1.jsx)(InputLabel_1.default, { children: "Test Type" }), (0, jsx_runtime_1.jsx)(Select_1.default, Object.assign({ color: 'primary', sx: { borderRadius: 5 }, value: testType, label: 'Test Type', onChange: handleChange }, { children: (testTypeList || []).map((type, idx) => {
                                                var _a;
                                                return ((0, jsx_runtime_1.jsx)(MenuItem_1.default, Object.assign({ value: type.id }, { children: (_a = type === null || type === void 0 ? void 0 : type.attributes) === null || _a === void 0 ? void 0 : _a.Name }), type.id));
                                            }) }))] })) })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: true }, { children: (0, jsx_runtime_1.jsx)(material_react_table_1.MaterialReactTable, { columns: columns, data: diagnosticData, initialState: {
                                        density: 'compact',
                                        expanded: true,
                                        grouping: ['firstGroup', 'category'],
                                        pagination: { pageIndex: 0, pageSize: 100 },
                                        sorting: [
                                            { id: 'firstGroup', desc: false },
                                            { id: 'category', desc: false },
                                        ],
                                    }, positionToolbarAlertBanner: 'none', enableColumnActions: false, enableColumnResizing: false, enableGrouping: true, manualGrouping: false, enableSorting: false, enableColumnDragging: false, enableStickyHeader: false, enableStickyFooter: false, enablePagination: false, enableBottomToolbar: false, enableHiding: false, enableGlobalFilter: false, enableFullScreenToggle: false, enableDensityToggle: false, enableFilters: false, muiToolbarAlertBannerChipProps: { color: 'primary' }, muiTableContainerProps: { sx: { maxHeight: '65vh' } }, muiTableBodyProps: {
                                        sx: (theme) => ({
                                            '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]) > td': {
                                                backgroundColor: (0, material_1.darken)('#cfd5ea', 0.1),
                                            },
                                            '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]):hover > td': {
                                                backgroundColor: (0, material_1.darken)('#cfd5ea', 0.2),
                                            },
                                            '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]) > td': {
                                                backgroundColor: (0, material_1.lighten)('#e9ebf5', 0.1),
                                            },
                                            '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]):hover > td': {
                                                backgroundColor: (0, material_1.darken)('#e9ebf5', 0.2),
                                            },
                                        }),
                                    }, mrtTheme: (theme) => ({
                                        baseBackgroundColor: '#4472c4',
                                    }), muiTableHeadCellProps: {
                                        sx: {
                                            color: 'white',
                                            fontSize: '1rem',
                                        },
                                    }, muiTopToolbarProps: {
                                        sx: {
                                            display: 'none',
                                        },
                                    } }) }))] }))), quizId && ((0, jsx_runtime_1.jsx)(Card_1.default, Object.assign({ sx: { margin: '20px 20%' } }, { children: (0, jsx_runtime_1.jsx)(CardContent_1.default, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ sx: { marginTop: 2, fontSize: '2vmax', textAlign: 'center', color: '#4472c4' } }, { children: "Timing" })), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ sx: { marginTop: 2, fontSize: '1.5vmax' } }, { children: "This diagnostic is timed and cannot be paused once the test begins. You will be notified if time runs out. However, you may continue answering questions after the time is up." })), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ sx: { marginTop: 2, fontSize: '2vmax', textAlign: 'center', color: '#4472c4' } }, { children: "Craft your Study Plan" })), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ sx: { marginTop: 2, fontSize: '1.5vmax' } }, { children: "This diagnostic is designed to help you identify your strengths and weaknesses, allowing you to craft your ideal study plan and track your progress." })), (0, jsx_runtime_1.jsxs)(Typography_1.default, Object.assign({ sx: { marginTop: 2, fontSize: '1.5vmax' } }, { children: ["After completing the diagnostic, click ", (0, jsx_runtime_1.jsx)("b", { children: "score details" }), " to view the type and difficulty of each question on the test. You can revisit questions and view explanations by clicking", ' ', (0, jsx_runtime_1.jsx)("b", { children: "review." })] })), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(Stack_1.default, Object.assign({ justifyContent: 'center', alignItems: 'center' }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ color: 'primary', variant: 'contained', sx: { borderRadius: 5, width: 500, fontSize: '1.5vmax', fontWeight: 600 }, onClick: handleStartQuizNew }, { children: "Start Your Test" })) }))] }) }) })))] })), (0, jsx_runtime_1.jsx)(AppBar_1.default, Object.assign({ color: 'default', position: 'fixed', sx: { top: 'auto', bottom: 0 } }, { children: (0, jsx_runtime_1.jsx)(Toolbar_1.default, { children: (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, spacing: { xs: 2, md: 3 }, columns: { xs: 4, sm: 8 } }, { children: [(0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 2, sm: 4, md: 4 }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: 'h6', component: 'div', sx: { flexGrow: 1 } }, { children: (userData === null || userData === void 0 ? void 0 : userData.firstName) || '' })) })), (0, jsx_runtime_1.jsx)(Grid_1.default, { item: true, xs: 2, sm: 4, md: 4, sx: { textAlign: 'right', textTransform: 'unset' } })] })) }) }))] }));
}
exports.default = Home;
